import {
    put,
    call,
    takeLatest,
} from "redux-saga/effects";
import { Actions as MasavExportsActions } from "./actions";
import { ActionTypes as PagesActions } from "../../pages/actions";
import axios from "../../services/axios";

function* fetchMasavExports(action) {
    let { payload } = action;
    try {
        yield put(MasavExportsActions.FETCH_MASAV_EXPORTS_REQUEST());
        
        const { data } = yield call(axios.get, 
            `/inquiries/masav-exports?page=${payload.page || 0}&take=${payload.take || 10}${payload.status ? `&status=${payload.status}` : ''}`
        );
        
        yield put(MasavExportsActions.FETCH_MASAV_EXPORTS_SUCCESS({ data }));
    } catch (err) {
        console.error(err);
        yield put(MasavExportsActions.FETCH_MASAV_EXPORTS_FAILURE(err));
    }
}

function* fetchSingleMasavExport(action) {
    let { payload } = action;
    try {
        yield put(MasavExportsActions.FETCH_SINGLE_MASAV_EXPORT_REQUEST());
        
        const { data } = yield call(axios.get, `/inquiries/masav-exports/${payload}`);
        
        yield put(MasavExportsActions.FETCH_SINGLE_MASAV_EXPORT_SUCCESS(data));
    } catch (err) {
        console.error(err);
        yield put(MasavExportsActions.FETCH_SINGLE_MASAV_EXPORT_FAILURE(err));
    }
}

function* uploadConfirmation(action) {
    let { payload } = action;
    try {
        yield put(MasavExportsActions.UPLOAD_CONFIRMATION_REQUEST());
        
        const formData = new FormData();
        formData.append('confirmationFile', payload.file);
        
        const { data } = yield call(
            axios.post, 
            `/inquiries/masav-export/${payload.masavExportId}/upload-confirmation`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        );
        
        yield put(MasavExportsActions.UPLOAD_CONFIRMATION_SUCCESS(data));
        
        // Refresh the export details
        yield put(MasavExportsActions.FETCH_SINGLE_MASAV_EXPORT_REQUEST());
        const refreshData = yield call(axios.get, `/inquiries/masav-exports/${payload.masavExportId}`);
        yield put(MasavExportsActions.FETCH_SINGLE_MASAV_EXPORT_SUCCESS(refreshData.data));
        
    } catch (err) {
        console.error(err);
        yield put(MasavExportsActions.UPLOAD_CONFIRMATION_FAILURE(err));
    }
}

const sagas = [
    takeLatest(PagesActions.MASAV_EXPORTS_PAGE_MOUNTED, fetchMasavExports),
    takeLatest(PagesActions.SINGLE_MASAV_EXPORT_PAGE_MOUNTED, fetchSingleMasavExport),
    takeLatest(PagesActions.UPLOAD_MASAV_CONFIRMATION_SUBMITTED, uploadConfirmation),
];

export default sagas;

